import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Translate from "./Translate";
import { useTranslator } from "./Translator";

const Input = ({
  type,
  name,
  label,
  placeholder,
  icon,
  iconUrl,
  disabled,
  isInvalid,
  invalidText,
  value,
  size = "sm",
  onChange,
}) => {
  const [translatedPlaceholder, setTranslatedPlaceholder] = useState("");
  const { translateText } = useTranslator();

  useEffect(() => {
    const translatePlaceholder = async (placeholder) => {
      const translated = await translateText(placeholder);
      setTranslatedPlaceholder(translated);
    };
    if (placeholder) {
      translatePlaceholder(placeholder);
    }
  }, [placeholder]);

  return (
    <div className="flex flex-col flex-1 gap-2 min-w-[150px] w-full">
      {label && <div className="text-gray-400">{label}</div>}
      <div
        className={`h-12 w-full border-[none] flex items-center justify-between relative
          bg-[#3a335066] rounded-md backdrop-blur-[2px] backdrop-brightness-[100%]
          [-webkit-backdrop-filter:blur(2px)_brightness(100%)]
          before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-md
          before:[background:linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(196,39,224,1)_16%,rgba(132,74,255,1)_47%,rgba(18,169,255,1)_83%,rgba(50,43,70,0)_97%)]
          before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]
          before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none
          ${isInvalid ? "border border-red-500 before:border-red-500" : ""}
        `}
      >
        {/* Left icon */}
        {icon && (
          <Icon
            icon={icon}
            className={`text-white/60 w-5 h-5 ml-2 z-10 pointer-events-none`}
          />
        )}
        {iconUrl && (
          <img
            src={iconUrl}
            alt="Icon"
            className="w-5 h-5 ml-2 object-cover z-10 pointer-events-none"
          />
        )}

        {/* Input field */}
        <input
          type={type}
          name={name}
          placeholder={translatedPlaceholder}
          disabled={disabled}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`bg-transparent outline-none px-2 text-white w-full ${
            disabled ? "cursor-not-allowed text-[#CCCCCC]" : ""
          } z-10`}
          style={{ paddingLeft: icon || iconUrl ? "2rem" : undefined }}
        />

        {/* Right icon or img placeholder */}
        {/* For example, if you want a fixed icon on right side, you can add it here */}
        {/* Replace or remove if not needed */}
      </div>
      {isInvalid && invalidText && (
        <div className="px-1">
          <span className="text-red-500 text-xs font-semibold">
            <Translate>{invalidText}</Translate>
          </span>
        </div>
      )}
    </div>
  );
};

export default Input;
